const trackingUtils = require('../../../../../webapp/static-content/_versionedByRelease_/js/modules/utils/tracking.utils');
const CATEGORY = 'my_area_trips_details';
const SIX_HOURS_IN_MILLS = 60 * 1000 * 60 * 6;
const ROUND_TRIP = 'ROUND_TRIP';
const CANCELLED_FLIGHT_STATUS = 'CANCELLED';

module.exports = {
    createAncillariesOffline(type, view, bookingInfo, selector, eventName) {
        const widgetPosition = view.widgetPosition;
        const trackEvent = function(action, labelPrefix) {
            const trackingAction = [action, type].join('_');
            const trackingLabelChunks = [labelPrefix, type];
            if (!Odigeo._.isUndefined(widgetPosition)) {
                trackingLabelChunks.push(`pos:${widgetPosition}`);
            }

            const trackingLabel = trackingLabelChunks.join('_');
            trackingUtils.trackEventWithCategory(CATEGORY, trackingAction, trackingLabel);
        };

        trackEvent('widget', 'show');

        return {
            openPopup() {
                trackEvent('widget', 'open');
                Odigeo.trigger(`${view.name}:${eventName}`, bookingInfo);
            },
            closePopup() {
                view.$el.find(selector).removeClass('opened open');
            },
        };
    },

    getLastDepartureDate(bookingInfo = {}) {
        const itineraryBookings = bookingInfo.itineraryBookings || {};
        const itinerarySegments = itineraryBookings.itinerarySegments || [];
        const lastDeparture = 0;

        return itinerarySegments.reduce((segmentAcc, segment) => {
            const sections = segment.sections || [];
            return sections.reduce((sectionAcc, section) => {
                const sectionDepartureDate = section.section.departureDate;
                return !sectionDepartureDate || sectionAcc > sectionDepartureDate
                    ? sectionAcc
                    : sectionDepartureDate;
            }, segmentAcc);
        }, lastDeparture);
    },

    getRemainingTimeToLastDeparture(bookingInfo = {}) {
        const lastSectionDepartureTimestamp = this.getLastDepartureDate(bookingInfo);
        return lastSectionDepartureTimestamp - new Date().getTime();
    },

    areAllFlightDeparted(bookingInfo = {}) {
        const remainingTimeToLastSectionDeparture = this.getRemainingTimeToLastDeparture(bookingInfo);
        return remainingTimeToLastSectionDeparture < 0;
    },

    remainsTimeToBookTheProduct(bookingInfo = {}) {
        const remainingTimeToLastSectionDeparture = this.getRemainingTimeToLastDeparture(bookingInfo);
        return remainingTimeToLastSectionDeparture > SIX_HOURS_IN_MILLS;
    },

    isRoundTrip(bookingInfo = {}) {
        const itineraryBookings = bookingInfo.itineraryBookings || {};
        const bookingItinerary = itineraryBookings.bookingItinerary || {};
        const tripType = bookingItinerary.tripType;
        return tripType === ROUND_TRIP;
    },

    haveAnyFlightCancelled(bookingInfo = {}) {
        const itineraryBookings = bookingInfo.itineraryBookings || {};
        const itinerarySegments = itineraryBookings.itinerarySegments || [];
        let anyCancelled = false;
        for (let i = 0; i < itinerarySegments.length && !anyCancelled; i++) {
            const segment = itinerarySegments[i];
            const sections = segment.sections || [];
            for (let j = 0; j < sections.length && !anyCancelled; j++) {
                const section = sections[j];
                anyCancelled = section.section.flightStatus === CANCELLED_FLIGHT_STATUS;
            }
        }

        return anyCancelled;
    },

    hideAncillaryCTAWhenNoCoverage(view, type) {
        if (!view.uiStrategy.isProductAvailable()) {
            Odigeo.trigger(`${view.name}:hideAncillaryCTA`, type);
        }
    },

    getSections(bookingInfo = {}) {
        const itinerarySegments = Odigeo._.get(bookingInfo, 'itineraryBookings.itinerarySegments', []);

        return itinerarySegments.reduce((sectionsAcc, segment, segmentIndex) => {
            const sections = segment.sections || [];

            sections.reduce((acc, sectionWrapper = {}, sectionIndex) => {
                const section = sectionWrapper.section || {};
                acc.push({
                    segmentIndex,
                    sectionIndex,
                    carrier: section.carrier.code,
                    from: section.from,
                    to: section.to,
                    id: section.id,
                    provider: sectionWrapper.provider,
                });

                return acc;
            }, sectionsAcc);

            return sectionsAcc;
        }, []);
    },

    findSelectedAncillaryBySection(section, selectedAncillariesList = []) {
        return selectedAncillariesList.find((selectedAncillary) =>
            selectedAncillary.sectionId === section.id
            && section.from.geoNodeId === selectedAncillary.from.geoNodeId
            && section.to.geoNodeId === selectedAncillary.to.geoNodeId
        );
    },
};
